import { render, staticRenderFns } from "./SearchTags.vue?vue&type=template&id=4cfe9db9&scoped=true"
import script from "./SearchTags.vue?vue&type=script&lang=js"
export * from "./SearchTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfe9db9",
  null
  
)

export default component.exports